import React, { useEffect, useState } from "react";
import "../Client_dashboard/Client_dashboard.css";
import { Outlet, Link, useNavigate } from "react-router-dom";
import close from "../../assets/close.png";
import Logo from "../../assets/logo2.png";
import LogoHalf from "../../assets/logo-half.png";
import axios from "axios";
import ProfileDropdown from "./ProfileDropdown";
import NotificationIcon from "./NotificationIcon";
import default_pic from "../../assets/Default_pfp.svg.png";
import { toast } from "react-toastify";
import {
  FaHome,
  FaUser,
  FaUserPlus,
  FaPhone,
  FaHeadset,
} from "react-icons/fa";
import { MdOutlineLogout } from "react-icons/md";
import { IoNotificationsOutline } from "react-icons/io5";
import { motion } from "framer-motion";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { HiMenuAlt2 } from "react-icons/hi";
import { getToken } from "../../utils/tokenService"; // Assuming you have a utility function to get the token

const UserDashboard = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(true);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [showEmergencyModal, setShowEmergencyModal] = useState(false);
  const [emergencyContactInput, setEmergencyContactInput] = useState("");
  const [savingEmergencyContact, setSavingEmergencyContact] = useState(false);

  async function fetchingProfile() {
    const token = await getToken();
    setLoading(true);
    try {
      await axios
        .get(`${process.env.REACT_APP_BACKEND_URL}/api/user/user-dashboard`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          console.log(res.data);
          setUser(res.data.currentUser);
          setLoading(false);
        });
    } catch (err) {
      toast.error("Try Again..");
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchingProfile();
  }, []);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const closeSidebar = () => {
    console.log(sidebarCollapsed);
    if(sidebarCollapsed) {
      setSidebarCollapsed(false);
    }
  };

  const openEmergencyContactModal = () => {
    setEmergencyContactInput(user?.emergency_contact || "");
    setShowEmergencyModal(true);
  };

  const closeEmergencyContactModal = () => {
    if (!savingEmergencyContact) {
      setShowEmergencyModal(false);
    }
  };

  const saveEmergencyContact = async () => {
    const emergency_contact = emergencyContactInput.trim();
    if (!/^[0-9]{10,15}$/.test(emergency_contact)) {
      toast.error("Enter a valid emergency contact (10 to 15 digits)");
      return;
    }

    const token = await getToken();
    setSavingEmergencyContact(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/user/profile/emergency-contact`,
        { emergency_contact },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setUser((prev) => ({
        ...(prev || {}),
        emergency_contact: res?.data?.emergency_contact || emergency_contact,
      }));
      toast.success("Emergency contact updated");
      setShowEmergencyModal(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Unable to update emergency contact");
    } finally {
      setSavingEmergencyContact(false);
    }
  };

  const navItems = [
    {
      path: "/user_dashboard/dashboard",
      icon: <FaHome />,
      label: "Dashboard",
      show: user?.job,
    },
    {
      path: "/user_dashboard/",
      icon: <FaHome />,
      label: "Jobs",
      show: user && !user.job,
    },
    {
      path: "/user_dashboard/user_profile",
      icon: <FaUser />,
      label: "Profile",
      show: true,
    },
    {
      path: "/user_dashboard/emergency-contact",
      icon: <FaPhone />,
      label: "Emergency Contact No.",
      show: true,
      onClick: openEmergencyContactModal,
    },
    {
      path: "/user_dashboard/support",
      icon: <FaHeadset />,
      label: "Support 24/7",
      show: true,
    },
    {
      path: "/logout",
      icon: <MdOutlineLogout />,
      label: "Logout",
      show: true,
    }
  ];

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Loading dashboard...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-wrapper user-dashboard-layout">
      <div
        className={`dashboard-container ${
          sidebarCollapsed ? "sidebar-collapsed" : ""
        }`}
        onClick={closeSidebar}
      >
        <nav className="sidebar">
          <div className="sidebar-header">
            <motion.img
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.3 }}
              src={sidebarCollapsed ? LogoHalf : Logo}
              alt="Company Logo"
              className={`company-logo ${sidebarCollapsed ? "logo-small" : ""}`}
            />
            <motion.button
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              className="sidebar-toggle desktop-only"
              onClick={toggleSidebar}
              title={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
            >
              {sidebarCollapsed ? (
                <MdKeyboardArrowRight />
              ) : (
                <MdKeyboardArrowLeft />
              )}
            </motion.button>
          </div>

          <div className="nav-links">
            {navItems.map(
              (item, index) =>
                item.show && (
                  <motion.div
                    key={index}
                    whileHover={{ x: 5 }}
                    transition={{ type: "spring", stiffness: 300 }}
                  >
                    <Link
                      to={item.path}
                      onClick={(e) => {
                        if (item.onClick) {
                          e.preventDefault();
                          item.onClick();
                        }
                      }}
                      className={`nav-item ${
                        window.location.pathname === item.path ? "active" : ""
                      }`}
                    >
                      <span className="nav-icon">{item.icon}</span>
                      <span
                        className={`nav-label ${
                          sidebarCollapsed ? "collapsed" : ""
                        }`}
                      >
                        {item.label}
                      </span>
                    </Link>
                  </motion.div>
                )
            )}
          </div>
        </nav>

        <main className="main-content" style={{paddingBottom : "20px"}}>
          {/* Mobile Header */}
          <div className="mobile-header">
            
            <div className="mobile-actions">
              {/* <ProfileDropdown profile_pic={user?.profilePic} /> */}
              <button className="mobile-menu-btn" onClick={toggleSidebar}>
                {sidebarCollapsed ? (
                  <MdKeyboardArrowLeft size={24} />
                ) : (
                  <HiMenuAlt2 size={24} />
                )}
              </button>
            </div>
            <div className="mobile-logo">
              <img
                src={Logo}
                alt="Company Logo"
                className="mobile-company-logo"
              />
            </div>
            <div style={{width: '48px'}}></div>
          </div>

          {/* Mobile Welcome Section */}
          <div className="mobile-welcome-section">
            <h1 className="mobile-welcome-text">
              Welcome, <span className="user-name">{user?.full_Name}</span>
            </h1>
            <p className="mobile-date-text">
              {new Date().toLocaleDateString("en-US", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </p>
          </div>

          {/* Desktop Header */}
          <div className="dashboard-header">
            <div className="desktop-header">
              <div className="header-left">
                <h1 className="welcome-text">
                  Welcome, <span className="user-name">{user?.full_Name}</span>
                </h1>
                <p className="date-text">
                  {new Date().toLocaleDateString("en-US", {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </p>
              </div>
              {/* <div className="header-actions">
                <NotificationIcon />
                <div className="divider-vertical"></div>
                <ProfileDropdown profile_pic={user?.profilePic} />
              </div> */}
            </div>
          </div>

          {/* Alert Section */}
          <div
            className="w-full d-flex flex-wrap gap-2 px-3"
            style={{ backgroundColor: "#1e3686", paddingBlock: "4px" }}
          >
            {" "}
            {!user.account_added && (
              <div className="d-flex gap-1">
                <p
                  className=""
                  style={{ color: "white", fontSize: "0.8rem", margin: "0px" }}
                >
                  You haven't add your Account
                </p>
                <button
                  onClick={() => {
                    navigate("/user_dashboard/add_account");
                  }}
                  className=""
                  style={{
                    background: "transparent",
                    fontSize: "0.7rem",
                    paddingInline: "2px",
                    color: "white",
                    border: "1px solid white",
                  }}
                >
                  Add Account
                </button>
              </div>
            )}
            {!user.pan_added && (
              <div className="d-flex gap-1">
                <p
                  className=""
                  style={{ color: "white", fontSize: "0.8rem", margin: "0px" }}
                >
                  You haven't add your Pan
                </p>
                <button
                  onClick={() => {
                    navigate("/user_dashboard/add_pan");
                  }}
                  className=""
                  style={{
                    background: "transparent",
                    fontSize: "0.7rem",
                    paddingInline: "2px",
                    color: "white",
                    border: "1px solid white",
                  }}
                >
                  Add Pan
                </button>
              </div>
            )}
          </div>

          <div className="content-area">
            <Outlet />
          </div>
        </main>
      </div>
      {showEmergencyModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1200,
            padding: "16px",
          }}
          onClick={closeEmergencyContactModal}
        >
          <div
            style={{
              backgroundColor: "#fff",
              width: "100%",
              maxWidth: "420px",
              borderRadius: "8px",
              padding: "18px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h5 style={{ marginBottom: "8px" }}>Emergency Contact Number</h5>
            <p style={{ marginBottom: "12px", fontSize: "0.9rem", color: "#666" }}>
              Add the number to be contacted in urgent situations.
            </p>
            <input
              type="tel"
              className="form-control"
              placeholder="Enter 10 to 15 digit number"
              value={emergencyContactInput}
              onChange={(e) =>
                setEmergencyContactInput(e.target.value.replace(/\D/g, ""))
              }
              maxLength={15}
            />
            <div
              style={{
                marginTop: "14px",
                display: "flex",
                justifyContent: "flex-end",
                gap: "8px",
              }}
            >
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={closeEmergencyContactModal}
                disabled={savingEmergencyContact}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={saveEmergencyContact}
                disabled={savingEmergencyContact}
              >
                {savingEmergencyContact ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserDashboard;
